import * as M from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useGetAiAgentServiceOperationSettingsHistory } from '../../../../../../shared/apis/ai-agent/company/reactQueries';

import * as C from '../../../../../ui/common/CommonStyles';

import AiAgentServiceOperationFilterSection from './ui/filterSection';
import OperationHistoryTable from './ui/operationHistoryTable';
import useServiceOperationHistoryFilters from './hooks/useServiceOperationHistoryFilters';

export default function ServiceOperationSettingHistory() {
  const { filterForm, queryParams, updateFilterForm, applyFilters, resetFilters, handlePageChange } =
    useServiceOperationHistoryFilters();
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('companyName') || '';

  const navigate = useNavigate();

  const { data } = useGetAiAgentServiceOperationSettingsHistory(queryParams);

  return (
    <M.Box>
      <C.TitleBox>
        <div className="title">AI-AGENT 서비스 운영 설정 이력</div>
      </C.TitleBox>
      <C.ListBox style={{ overflowX: 'visible' }}>
        <M.Stack gap="lg">
          <M.Flex
            gap="md"
            align="center"
            justify="space-between"
            style={(theme) => ({
              border: `1px solid ${theme.colors.gray[3]}`,
              backgroundColor: theme.colors.gray[0],
              borderRadius: theme.radius.sm,
              padding: theme.spacing.sm,
            })}
          >
            <M.Box>
              <M.Text size="xs" c="gray.6">
                거래처명
              </M.Text>
              <M.Text fw={500}>{companyName}</M.Text>
            </M.Box>
            <M.Button
              variant="default"
              size="xs"
              leftSection={<IconChevronLeft size={14} />}
              onClick={() => navigate('/admin/management/aiagent/company')}
            >
              목록으로
            </M.Button>
          </M.Flex>
          <AiAgentServiceOperationFilterSection
            filterForm={filterForm}
            onChangeFilterForm={updateFilterForm}
            onSearch={applyFilters}
            onReset={resetFilters}
          />
          <OperationHistoryTable
            data={data}
            page={queryParams.page ?? 1}
            size={queryParams.size ?? 10}
            onPageChange={handlePageChange}
          />
        </M.Stack>
      </C.ListBox>
    </M.Box>
  );
}
